import { bool } from 'prop-types'

import Modal from '@mui/material/Modal'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'

const Progress = styled(CircularProgress)({
  color: 'white',
})

function LoadingIcon({ open }) {
  const styleDiv = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    top: '50%',
    position: 'relative',
  }
  return (
    <Modal open={open} disableAutoFocus>
      <div style={styleDiv}>
        <Progress style={{ margin: 'auto' }} />
      </div>
    </Modal>
  )
}
LoadingIcon.propTypes = {
  open: bool.isRequired,
}
export default LoadingIcon
